import React, { useState, useEffect } from 'react';

import { Slider } from 'antd';

import { FormattedMessage } from 'react-intl';

import { RTService } from '../../RideTwister.service';

let time = null;

const RideTwisterSlider = (props) => {
  const { sliderValue, setSliderValue, setActiveSetting, activeSetting } =
    props;

  const [val, setVal] = useState(sliderValue);

  const { isActiveSetting, getSliderByCoefficient } = RTService;

  const getSlider = (val) => getSliderByCoefficient(val);

  useEffect(() => {
    if (sliderValue !== val) {
      setVal(getSlider(sliderValue));
    }
  }, [sliderValue]);

  const onChange = (val) => {
    setVal(val);
    setActiveSetting(val);
    if (time) {
      clearTimeout(time);
    }

    time = setTimeout(() => {
      setSliderValue(val);
    }, 500);
  };

  const getActiveClass = () =>
    isActiveSetting(activeSetting) ? 'rtSlider active' : 'rtSlider';

  return (
    <div className="rtSliderLayout">
      <div className="rtSliderlabel">
        <FormattedMessage
          id="Slide to twist your ride"
          defaultMessage="Slide to twist your ride"
        />
      </div>
      <div className={getActiveClass()}>
        <Slider
          min={0}
          max={100}
          onChange={onChange}
          value={val}
          tooltipVisible={false}
        />
      </div>
    </div>
  );
};

export default RideTwisterSlider;
